import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Response } from "@angular/http";

@Injectable()
export class HttpIntegrationService {

    private subject = new Subject<Response>();

    public OnError = this.subject.asObservable();

    public error(res: Response) {
        this.subject.next(res);
    }
}